'use client'
import { useGetAdsQuery } from '@/app/globalRedux/api/adsSlice'
import { useGetCompanyProductFamilyQuery } from '@/app/globalRedux/api/filter/companySearchSlice'
import { useGetSalesOfferQuery } from '@/app/globalRedux/api/searchSlice'
import { setListedProductFamily } from '@/app/globalRedux/filterList/companyFilterList'
import {
  setProductListedBuyerSupplier,
  setProductListedProductFamily,
  setProductListedProductFamilyCount,
} from '@/app/globalRedux/filterList/productFilterList'
import { AppDispatch, RootState } from '@/app/globalRedux/store'
import { AdBannerScheduleType } from '@/app/types/adType'
import { ProductFamilyListResponse } from '@/app/types/companySearchType'
import { ProductSearchResponse } from '@/app/types/productSearchType'
import { getCountryList } from '@/services/generalDataServices'
import { useParams, usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import RightAdsPanel from '../../../components/AdsFructidor/RightAdsPanel/RightAdsPanel'
import { ProductPage } from '../../search/product-tab/ProductPage'
import { convertNaNToOne } from '@/lib/formatUtils'
import humanizeString from 'humanize-string'
import { addOrRemoveFvProductFilterSelectedProduct } from '@/app/globalRedux/filter/productFilter'
import { useRouter } from 'next/navigation'

const SalesOfferPage = () => {
  const dispatch: AppDispatch = useDispatch()
  const params = useParams<{ lng: string; productPageNO: string[] }>()
  const queryParams = useSearchParams()
  const productsFilter = useSelector((state: RootState) => state.productFilter)
  const productId = queryParams.get('product_id')
  const productName = humanizeString(String(queryParams.get('product_name')))
  const pathname = usePathname()
  const router = useRouter()
  const countryList = useSelector(
    (state: RootState) => state.constantData.countriesList
  )
  const commonFilter = useSelector((state: RootState) => state.commonFilter)

  useEffect(() => {
    if (countryList.length <= 0) {
      dispatch(getCountryList())
    }
  }, [])

  useEffect(() => {
    if (productId) {
      dispatch(
        addOrRemoveFvProductFilterSelectedProduct({
          id: Number(productId),
          name: productName,
          checked: true,
        })
      )
      router.push(pathname)
    }
  }, [productId])

  const {
    data: salesData,
    isFetching: isSalesDataFetching,
    isError: isSalerDataError,
  } = useGetSalesOfferQuery<{
    data: ProductSearchResponse
    isFetching: boolean
    isError: boolean
    isSuccess: boolean
  }>(
    {
      productsFilter: productsFilter,
      commonFilter: commonFilter,
      pageNo: convertNaNToOne(Number(params?.productPageNO?.[0]) || 1),
    },
    {
      skip: productsFilter?.isRouteUpdating,
    }
  )
  const { data: productfamilyData, isLoading: isProductFamilyLoading } =
    useGetCompanyProductFamilyQuery<{
      data: ProductFamilyListResponse
      isLoading: boolean
      isError: boolean
    }>(productsFilter.sector)
  const { data: salesOfferAds } = useGetAdsQuery<{
    data: AdBannerScheduleType[]
    isLoading: boolean
    isError: boolean
    isFetching: boolean
  }>({ page: 'Offers Listing', lang: params.lng })
  useEffect(() => {
    if (productfamilyData && !isProductFamilyLoading) {
      dispatch(setListedProductFamily(productfamilyData.product_families))
      dispatch(
        setProductListedProductFamily(productfamilyData.product_families)
      )
    }
  }, [productfamilyData])

  useEffect(() => {
    if (salesData) {
      dispatch(
        setProductListedBuyerSupplier([
          ...(salesData?.facet_count?.activities ?? []),
        ])
      )
      dispatch(
        setProductListedProductFamilyCount([
          ...(salesData?.facet_count?.product_family ?? []),
        ])
      )
    }
  }, [isSalesDataFetching, salesData])
  return (
    <div>
      <div className="flex justify-center mt-[30px] mobile:flex-col mobile:mt-[10px]">
        <div className="w-[1280px] flex justify-between mobile-width mobile:flex-col">
          <div className="  mb-[30px] mobile:mb-[15px]">
            <ProductPage
              adList={salesOfferAds ?? []}
              productData={salesData}
              isLoading={isSalerDataError || isSalesDataFetching}
            />
          </div>
          <RightAdsPanel />
        </div>
      </div>
    </div>
  )
}

export default SalesOfferPage
